<template>
  <div class="certificationWrap">
    <!-- header -->
    <Header />

    <!-- certification -->
    <div class="certification">
      <div class="w1200">
        <!-- title -->
        <div class="title">
          <img src="~@/assets/images/title_ryzz.png" alt="荣誉资质" />
        </div>

        <!-- 走马灯 -->
        <Carousel
          v-model="value1"
          :loop="setting.loop"
          :autoplay="setting.autoplay"
          :autoplay-speed="setting.autoplaySpeed"
          :dots="setting.dots"
          :radius-dot="setting.radiusDot"
          :trigger="setting.trigger"
          :arrow="setting.arrow"
          @on-change="change"
        >
          <CarouselItem v-for="(carouse, curPage) in totalPage" :key="curPage">
            <!-- {{curPage}} -->
            <div class="certification_panel clearfix">
              <!-- <dl v-for="(item, index) in list.slice(curPage * 8, (curPage + 1) * 8)" :key="index"> -->
              <dl v-for="(item, index) in list" :key="index">
                <router-link
                  :to="{
                    name: 'Show',
                    params: { type: 'certification', id: item.id, pageNo: ((pageNo-1) * pageSize + (index + 1)), count: totalCount },
                  }"
                >
                  <dt>
                    <img :src="origin + item.imgUrl" :alt="item.name" />
                  </dt>
                  <dd>
                    <h3>{{ item.name }}</h3>
                    <span>{{ item.remarks }}</span> 
                  </dd>
                </router-link>
              </dl>
            </div>
          </CarouselItem>
        </Carousel>
      </div>
    </div>

    <!-- timeline -->
    <div class="timeline" style="margin-top: 20px;">
      <div class="w1200">
        <div class="title">
          <img src="~@/assets/images/title_fzlc.png" alt />
        </div>

        <!-- 走马灯 -->
        <Carousel
          v-model="value2"
          :autoplay="setting.autoplay"
          :autoplay-speed="setting.autoplaySpeed"
          :dots="setting.dots"
          :radius-dot="setting.radiusDot"
          :trigger="setting.trigger"
          :arrow="setting.arrow"
        >
          <CarouselItem v-for="(item, index) in developmentData" :key="index">
            <dl class="timeline_panel">
              <dd>
                <!-- {{ item.remarks }} -->
                <p v-for="(remark, i) in item.remarks.split('-').slice(1)" :key="i">
                  - {{remark}}
                </p>
              </dd>
              <dt>{{ item.year }}</dt>
            </dl>
          </CarouselItem>
        </Carousel>
      </div>
    </div>

    <!-- certification_mobile -->
    <div class="certification_mobile">
      <!-- 荣誉资质 -->
      <div class="aptitude">
        <!-- title -->
        <div class="title">
          <img src="~@/assets/images/title_ryzz.png" alt="荣誉资质" />
        </div>
        <!-- Swiper -->
        <!-- <div class="swiper-container swiper-container-certification swiper-no-swiping"> -->
        
        <div
          class="swiper-container swiper-container-certification swiper-no-swiping"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide clearfix"
              v-for="(carouse, curPage) in Math.ceil(totalCount / 2)"
              :key="curPage"
            >
              <dl v-for="(item, index) in list" :key="index">
                <router-link
                  :to="{
                    name: 'Show',
                    params: { type: 'certification', id: item.id },
                  }"
                >
                  <dt>
                    <img :src="origin + item.imgUrl" :alt="item.remarks" />
                  </dt>
                  <dd>{{ item.remarks }}</dd>
                </router-link>
              </dl>
            </div>
          </div>
          <div class="swiper-button-next">
            <i class="iconfont icon-arrow-right-ico"></i>
          </div>
          <div class="swiper-button-prev">
            <i class="iconfont icon-fanhui"></i>
          </div>
          <div class="swiper-pagination"></div>
        </div>


      </div>

      <!-- 发展历程 -->
      <div class="history">
        <div class="title">
          <img src="~@/assets/images/title_fzlc.png" alt />
        </div>

        <!-- Swiper -->
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in developmentData"
              :key="index"
            >
              <dl class="timeline_panel">
                <!-- <dd>{{ item.remarks }}</dd> -->
                <dd>
                  <p v-for="(remark, i) in item.remarks.split('-').slice(1)" :key="i">
                  - {{remark}}
                </p>
                </dd>
                <dt>{{ item.year }}</dt>
              </dl>
            </div>
          </div>
          <!-- Add Arrows -->
          <div class="swiper-button-next">
            <i class="iconfont icon-arrow-right-ico"></i>
          </div>
          <div class="swiper-button-prev">
            <i class="iconfont icon-fanhui"></i>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination" style="display: none;"></div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <Footer />
  </div>
</template>

<script>
import { Qualification, AllQualification, Development } from "@/api/http";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Vue from "vue";
import { Carousel, CarouselItem } from "iview";
Vue.component("Carousel", Carousel);
Vue.component("CarouselItem", CarouselItem);
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  name: "certification",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      value1: 0,
      value2: 2,
      setting: {
        loop: false,
        autoplay: false,
        autoplaySpeed: 2000,
        dots: "inside",
        radiusDot: false,
        trigger: "click",
        arrow: "always",
      },

      origin: "", // 域名
      developmentData: [], // 发展历程数据
      totalCount: 0, // 总条数
      totalPage: 1, // 总页码
      pageNo: 1, // 默认显示第1页
      pageSize: 8, // 当前页显示条数
      list: [], // 资质数据
      swiperActiveIndex: 0,

      allQualificationList: [] // 所有资质
    };
  },
  created() {
    // 资质
    if (this.mobileDevice()) {
      // 移动端无分页，显示全部
      this.getQualification(this.pageNo, 2);
      // 获取所有资质
      this.getAllQualification();
    } else {
      this.getQualification(this.pageNo, this.pageSize);
    }

    // 发展历程
    this.getDevelopment();
  },
  mounted() {},
  updated() {
    
  },
  methods: {
    // pc翻页
    change(oldValue, value) {
      // console.log(value);
      this.pageNo = value + 1;
      this.$nextTick(() => {
        this.getQualification(value + 1, this.pageSize);
      });
    },

    // 初始化资质swiper
    initSwiperQualification() {
      var swiperCertification = new Swiper(".swiper-container-certification", {
        cssMode: true,
        loop: true,
        spaceBetween: 5,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        pagination: ".swiper-pagination",
        paginationClickable: true,
        mousewheel: true,
        keyboard: true,
        onSlideChangeEnd: (swiperCertification) => {
          // 左右箭头切换事件
          // console.log(swiperCertification.activeIndex);
          this.swiperActiveIndex = swiperCertification.activeIndex;
          // alert(swiperCertification.activeIndex)   //切换结束时，告诉我现在是第几个slide
          // this.$nextTick(() => {
          // this.getQualification(swiperCertification.activeIndex, 2);
          Qualification({
            pageNo: swiperCertification.activeIndex,
            pageSize: 2,
          })
            .then((res) => {
              // console.log(res);

              this.origin = this.$origin;
              this.totalCount = res.data.count;
              this.list = res.data.list;
              // 一共几页
              this.totalPage = Math.ceil(this.totalCount / this.pageSize);
            })
            .catch((err) => {
              console.log("数据加载失败，请稍后重试");
            });
          // });
        },

        onTouchMove: (swiperCertification, event) => {
          // alert(1);
        },

        // onTouchEnd: (swiperCertification, event) => {  // 滑动事件
        //   alert(this.swiperActiveIndex);
        // }

        // onSlideNextStart: (swiperCertification) => {
        //   alert(this.swiperActiveIndex);
        // }
      });
    },

    // 初始化swiper
    initSwiper() {
      var swiper = new Swiper(".swiper-container", {
        cssMode: true,
        loop: true,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        pagination: ".swiper-pagination",
        paginationClickable: true,
        mousewheel: true,
        keyboard: true,
      });
    },

    // 资质--分页
    getQualification(pageNo, pageSize) {
      Qualification({
        pageNo: pageNo,
        pageSize: pageSize,
      })
        .then((res) => {
          // console.log(res);

          this.origin = this.$origin;
          this.totalCount = res.data.count;
          this.list = res.data.list;
          // 一共几页
          this.totalPage = Math.ceil(this.totalCount / this.pageSize);
          // console.log(this.totalPage);

          // 在获取完数据后，将swiper放在$nextTick下一个UI帧再初始化。
          if (this.mobileDevice()) {
            this.$nextTick(() => {
              this.initSwiperQualification();
            });
          }
        })
        .catch((err) => {
          console.log("数据加载失败，请稍后重试");
        });
    },

    // 资质--所有
    getAllQualification() {
      AllQualification()
      .then(res => {
        // console.log(res);
        this.allQualificationList = res.data;
      })
      .catch((err) => {
        console.log("数据加载失败，请稍后重试");
      });
    },

    // 发展历程
    getDevelopment() {
      Development()
        .then((res) => {
          // console.log(res);
          this.developmentData = res.data.reverse();

          // 在获取完数据后，将swiper放在$nextTick下一个UI帧再初始化。
          if (this.mobileDevice()) {
            this.$nextTick(() => {
              this.initSwiper();
            });
          }
        })
        .catch((err) => {
          console.log("数据加载失败，请稍后重试");
        });
    },

    // 判断移动设备
    mobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
  },
  // watch: {
  //   list(newVal, oldVal) {
  //     this.list = newVal;
  //     // console.log(this.list);
  //   }
  // }
};
</script>

<style lang="scss">
@import "@/assets/styles/certification";
</style>
